import { render } from "./ExitLogo.vue?vue&type=template&id=8b00f0ae"
import script from "./ExitLogo.vue?vue&type=script&lang=js"
export * from "./ExitLogo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__